
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';

import './app/services/apm-opentelemetry-config';
import { initTracing } from './app/services/apm-opentelemetry-config';

initTracing().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      provideHttpClient(withInterceptorsFromDi()),

      // ✅ Import old NgModule providers correctly
      importProvidersFrom(
        AppModule,
        BrowserAnimationsModule
      )
    ]
  }).catch(err => console.error(err));
});
